import React, { useRef, useState } from "react";
import { FaUserAlt } from "react-icons/fa";
import { AiFillLike, AiFillDislike } from "react-icons/ai";
import { Like_disLike } from './voteLike';
import ButtonPagination from "../ButtonPagination";
import Vote from './vote';
import {
    userDislikeCommentsProduct,
    userLikeCommentsProduct
} from "../../auth/apiProduct";
import './UserComment.css';

const UserComment = (props) => {
    const {
        infoSource,
        skip,
        limit,
        voteA,
        setCommentsPro,
        siseProduct,
        commentProduct,
        SetSizeComments,
        setUserVote,
        comments = [],
        productId,
        token,
        loadMore,
        loadMore0,
        ButtonProductPreview,
        size,
        ButtonBool = true,
    } = props;

    const { userInfo } = infoSource;
    const pendingReactions = useRef(new Set());
    const [, forcePendingRender] = useState(0);

    const updateReaction = async (commentId, reactionRequest) => {
        if (!token || !productId || pendingReactions.current.has(commentId)) return;
        pendingReactions.current.add(commentId);
        forcePendingRender((value) => value + 1);
        try {
            const result = await reactionRequest(token, productId, commentId);
            if (result?.success === false) return;
            const refreshed = await commentProduct(productId, skip, limit);
            if (!refreshed || refreshed.error) return;
            setCommentsPro(refreshed.commentsPagination);
            SetSizeComments(refreshed.commentsCount?.[0]?.totalComments);
            setUserVote(refreshed.userVote?.[0]?.vote);
        } finally {
            pendingReactions.current.delete(commentId);
            forcePendingRender((value) => value + 1);
        }
    };

    const voteDisLike = comentID => {
        updateReaction(comentID, userDislikeCommentsProduct);
    };

    const voteLike = comentID => {
        updateReaction(comentID, userLikeCommentsProduct);
    };

    const isMyComment = (comment) => {
        return userInfo?._id === comment?.user;
    };

    const getUserName = (comment) => {
        if (comment.username) return comment.username;
        
        let first1 = String(comment.firstname).charAt(0);
        let last1 = String(comment.lastname).charAt(0);
        return first1.concat(last1).toLocaleUpperCase();
    };

    const getUserVote = (comment) => {
        const userVote = voteA?.find(v => v.userId === comment.user);
        return userVote ? <Vote rating={userVote.voteNum} /> : null;
    };

    const LikeDislikeButtons = ({ comment }) => (
        <div className="comment-actions">
            <button
                className="action-btn-like dislike-btn"
                onClick={() => voteDisLike(comment._id)}
                disabled={!productId || pendingReactions.current.has(comment._id)}
            >
                <AiFillDislike />
                <span className="action-count">
                    {Like_disLike(comment.Like, false)}
                </span>
            </button>
            <button
                className="action-btn-like like-btn"
                onClick={() => voteLike(comment._id)}
                disabled={!productId || pendingReactions.current.has(comment._id)}
            >
                <AiFillLike />
                <span className="action-count">
                    {Like_disLike(comment.Like, true)}
                </span>
            </button>
        </div>
    );

    const CommentBubble = ({ comment, index }) => {
        const isMe = isMyComment(comment);

        return (
            <div
                className={`comment-item ${isMe ? 'comment-me' : 'comment-other'}`}
                style={{ animationDelay: `${index * 0.05}s` }}
            >
                <div className="comment-bubble">
                    {/* User Info */}
                    <div className="comment-header">
                        <div className="user-info">
                            <div className="user-avatar">
                                <FaUserAlt />
                            </div>
                            <div className="user-details">
                                <span className="user-name">
                                    {getUserName(comment)}
                                </span>
                                <div className="user-rating">
                                    {getUserVote(comment)}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Comment Content */}
                    <div className="comment-content">
                        {comment.title && (
                            <h4
                                className="comment-title"
                                dangerouslySetInnerHTML={{ __html: comment.title }}
                            />
                        )}
                        <p
                            className="comment-text"
                            dangerouslySetInnerHTML={{ __html: comment.description }}
                        />
                    </div>

                    {/* Like/Dislike */}
                    <LikeDislikeButtons comment={comment} />
                </div>
            </div>
        );
    };

    return (
        <div className="user-comments-section">
            <div className="comments-list">
                {comments?.map((comment, i) => (
                    <CommentBubble key={i} comment={comment} index={i} />
                ))}
            </div>

            {ButtonBool && (
                <div className="comments-footer">
                    <ButtonPagination
                        infoSource={infoSource}
                        size={siseProduct || size}
                        skip={skip}
                        limit={limit}
                        siseProduct={siseProduct}
                        loadMore={loadMore}
                        loadMore0={loadMore0}
                        // buttonClassL="pagination-btn pagination-prev"
                        // buttonClassLD="pagination-btn pagination-prev-disabled"
                        // buttonClassR="pagination-btn pagination-next"
                        // buttonClassRD="pagination-btn pagination-next-disabled"
                    />
                    <button
                        className="cancel-btn"
                        onClick={() => ButtonProductPreview()}
                    >
                        {infoSource.laguangeElakay('Button', infoSource.languageAPI).cancel}
                    </button>
                </div>
            )}
        </div>
    );
};

export default UserComment;
